import React, { FC } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import FrSearchSvg from '@src/svgs/fr-search.svg';
import FrCloseSvg from '@src/svgs/fr-close.svg';
import { SearchFieldProps } from './props';
import './styles.scss';

export const SearchField: FC<SearchFieldProps> = ({
  className,
  value,
  onChange,
  onClear,
  placeholder,
  iconClassName,
  closeIconClassName,
}) => {
  return (
    <div className={classnames('fr-search-field', className)}>
      <Svg
        className={classnames('fr-search-field__icon', 'fr-search-field__icon--search', iconClassName)}
        src={FrSearchSvg}
      />

      <input onChange={e => onChange(e.target.value)} placeholder={placeholder} type="text" value={value} />

      <Svg
        className={classnames(
          'fr-search-field__icon fr-search-field__icon--clear',
          !!value && 'fr-search-field__icon--is-shown',
          closeIconClassName,
        )}
        onClick={onClear}
        src={FrCloseSvg}
      />
    </div>
  );
};
